import Dashboard from './Dashboard';
import { Provider, ErrorBoundary } from '@rollbar/react'; 
import { GoogleOAuthProvider } from '@react-oauth/google';

import './App.css';

const rollbarConfig = {
  accessToken: '47fc70cdd4e4432f9e729720d298f3e8',
  environment: process.env.NODE_ENV || 'development',
  captureUncaught: true,
  autoInstrument: true,
  captureUnhandledRejections: true,
  payload: {
    server: {
      root: "https://pattern-bin.com/",
      branch: "main"
    },
    client: {
      javascript: {
        code_version: "0.0.2",
        source_map_enabled: true
      }
    }
  },
  checkIgnore: function(isUncaught, args, payload) {
    // Ignore Google OAuth telemetry CORS errors
    if (payload && payload.body && payload.body.message) {
      const message = payload.body.message.body;
      if (message && typeof message === 'string') {
        if (message.includes('accounts.google.com/gsi/log')) return true;
        if (message.includes('api.rollbar.com')) return true;
      }
    }
    return false;
  }
}


function App() {
  return (
    /* Provider instantiates Rollbar client instance handling any uncaught errors or unhandled promises in the browser */
    <Provider config={rollbarConfig}>
      {/* ErrorBoundary catches all React errors in the tree below and logs them to Rollbar */}
      <ErrorBoundary errorMessage={"Some error"}>
        <GoogleOAuthProvider clientId="269274648664-arveomld6t19l3raset7db0k07lhcrcs.apps.googleusercontent.com">
          <div className="App">
            <Dashboard />
          </div>
        </GoogleOAuthProvider>
      </ErrorBoundary>
    </Provider>
  );
}

export default App;
